import request from '@/utils/request'

// 待审核任务
export function getCollectionPage(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/page', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取馆藏和资源记录（包括删除的）
export function collectionResourceRecord(data) {
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/adks-app/collection/collectionResourceRecord',
  //   method: 'get',
  //   params: data
  // })
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/collectionResourceRecord', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 批量/单个审核不通过接口   //弃置
export function collectionFailure(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/collectionFailure', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 批量/单个审核通过接口
export function collectionSuccessful(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/collectionSuccessful', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量/单个审核存疑
export function collectionDoubt(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/collectionDoubt', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 入藏
export function collectionProofreadingList(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/collectionProofreadingList', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 馆藏发布”已发布馆藏“列表接口   请求：http://39.97.224.82:5000/adks-app/collection/page?status=8&releaseStatus=1
// 参数status和publisherStatus是默认参数 第一个是8代表-发布步骤  第二个参数1代表 已发布

// 馆藏发布”待发布馆藏“列表接口   请求：http://39.97.224.82:5000/adks-app/collection/page?status=7&releaseStatus=0
// 参数status和publisherStatus是默认参数 第一个是7代表-存储转码步骤  第二个参数0代表待入藏状态
export function collectionPage(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/page', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 发布接口  请求：http://39.97.224.82:5000/adks-app/collection/collectionReleaseList?collectionId=1,2  请求类型POST 参数collectionId是馆藏的主键id拼接字符串 如果一个馆藏（列如collectionId=1）如果多个（列如collectionId=1,2,3,4）

export function collectionReleaseList(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/collectionReleaseList', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 取消发布接口  请求：http://39.97.224.82:5000/adks-app/collection/cancelCollectionReleaseList?collectionId=1,2  请求类型POST 参数collectionId是馆藏的主键id拼接字符串 如果一个馆藏（列如collectionId=1）如果多个（列如collectionId=1,2,3,4）

export function cancelCollectionReleaseList(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/cancelCollectionReleaseList', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 详情页面
export function collectionPageDes(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/detail', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 详情审校入藏接口 修改详情
export function collectionProofreading(data) {
  return new Promise((resolve, reject) => {
    request.postdata('/adks-app/collection/collectionProofreading', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// http://39.97.224.82:5000/adks-app/resource/remove?ids=1,2  （ids传的是资源主键id的字符串拼接）
// 删除资源
export function removeResourse(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/resource/remove', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 删除馆藏
export function removeCollection(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/remove', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 解析著录文件
export function catalogingParseExcel(data) {
  return new Promise((resolve, reject) => {
    request.postDataWithHeader('/adks-app/collection/cataloging/parseExcel', data, { 'Content-Type': 'multipart/form-data' }).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询馆藏及资源信息
export function collectionResource(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/collectionResource', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 审核人列表
export function getAuditUser(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/getAuditUser', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 资源ai审核  ids 馆藏id,多个用逗号隔开
export function textAudit(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/textAudit', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 资源ai审核  ids 馆藏id,多个用逗号隔开
export function collectionfileAudit(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/fileAudit', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 查询任务状态 type任务类型: transcoding:转码, audit:审核              ids 馆藏id,多个用逗号隔开
export function aiTask(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/aiTask', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 标准转码  ids 馆藏id,多个用逗号隔开
export function standardTranscoding(data) {
  return new Promise((resolve, reject) => {
    request.post('/adks-app/collection/standardTranscoding', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/adks-app/collection/standardTranscoding',
  //   method: 'post',
  //   params: data
  // })
}

// 参考词提取 inputReferParseVO address datetimes input persons
export function inputReferParse(data) {
  return new Promise((resolve, reject) => {
    request.postdata('/adks-app/inputRefer/parse', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/adks-app/inputRefer/parse',
  //   method: 'post',
  //   data: data
  // })
}
// 馆藏著录
export function cataloging(data) {
  return new Promise((resolve, reject) => {
    request.postdata('/adks-app/collection/cataloging', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/adks-app/collection/cataloging',
  //   method: 'post',
  //   data: data
  // })
}

// 行政区域模糊查询
export function regionlistByName(data) {
  return new Promise((resolve, reject) => {
    request.get('/ha-base/region/listByName', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/ha-base/region/listByName',
  //   method: 'get',
  //   params: data
  // })
}

// 著录完成之后
export function collectiongetById(data) {
  return new Promise((resolve, reject) => {
    request.get('/adks-app/collection/getByIds', data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
  // return request({
  //   // baseURL:'http://localhost:8089/dev-api/',
  //   url: '/adks-app/collection/getById',
  //   method: 'get',
  //   params: data
  // })
}
